module.exports = __webpack_public_path__ + "img/complete_count.c0ba9a51.svg";